import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import PlateSizeEditor from '../editors/custom-editors/PlateSizeEditor';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {CUSTOM_COMPONENT_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

const FILL_PLATE_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.FILL_PLATE, 0).fields
);

export const FILL_PLATE_V0_UI_SCHEMA = {
  ...FILL_PLATE_BASE_UI_SCHEMA,
  [FIELD_ORDER_UI_SCHEMA_KEY]: [
    'name',
    'plateHeight',
    'contentsColumnMapping',
    'labelsColumnMapping',
    'concentrationDesignColumnMapping',
    'metadataColumnMapping',
  ],
  plateHeight: {
    ...FILL_PLATE_BASE_UI_SCHEMA.plateHeight,
    displayName: 'Plate size',
    [CUSTOM_COMPONENT_KEY]: PlateSizeEditor,
  },
  contentsColumnMapping: {
    ...FILL_PLATE_BASE_UI_SCHEMA.contentsColumnMapping,
    fieldSettings: {
      subfieldInfoText: {
        plate_id:
          'Groups rows into plates by source plate ID — rows sharing an ID fill the same plate. Use this or plate index, not both.',
        plate_index:
          'Groups rows into plates by number — rows sharing an index fill the same plate. Use this or plate ID, not both. Omit both for a single plate.',
        well_position: 'Excel-style well label (A1). Set this, or both row and column index.',
        entity_id: 'API ID of the entity to place — set this or a container, not both',
        container_id: 'API ID of a container whose contents to place — set this or an entity, not both',
        content_concentration_amount:
          'Concentration of the placed content — unit id/version required when set',
        transfer_quantity_amount: 'Volume recorded with the placement — unit id/version required when set',
        concentration_layer_name: 'Name of the concentration design layer this well belongs to',
        concentration_design_amount: 'Concentration amount for this well in the named design layer',
      },
    },
  },
  labelsColumnMapping: {
    ...FILL_PLATE_BASE_UI_SCHEMA.labelsColumnMapping,
    fieldSettings: {
      subfieldInfoText: {
        well_position: 'Excel-style well label (A1). Set this, or both row and column index.',
        well_volume_amount: 'Final volume for the well — unit id/version required when set',
      },
    },
  },
  concentrationDesignColumnMapping: {
    ...FILL_PLATE_BASE_UI_SCHEMA.concentrationDesignColumnMapping,
    fieldSettings: {
      subfieldInfoText: {
        well_position: 'Excel-style well label (A1). Set this, or both row and column index.',
        concentration_layer_name: 'Name of the concentration design layer this well belongs to',
        concentration_design_amount: 'Concentration amount for this well in the named design layer',
      },
    },
  },
  metadataColumnMapping: {
    ...FILL_PLATE_BASE_UI_SCHEMA.metadataColumnMapping,
    fieldSettings: {
      subfieldInfoText: {
        well_position:
          'Excel-style well label (A1). Set this, or both row and column index. Every other column becomes a metadata layer.',
      },
    },
  },
} as unknown as StepTypeConfigUISchemaV2<PipelineStepType.FILL_PLATE, 0>;
